export default function createGeoJson(data) {
  if (!data) {
    throw new Error('Passed no data');
  }

  if (!Array.isArray(data)) {
    throw new Error('Passed incorrect type of data');
  }

  return {
    type: 'FeatureCollection',
    features: data.map((country, index) => {
      const { lat, long: lng } = country;
      return {
        type: 'Feature',
        properties: {
          ...country,
          id: index,
        },
        geometry: {
          type: 'Point',
          coordinates: [lat, lng],
        },
      };
    }),
  };
}
